// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/secret.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { GetRequestSchema, ListRequestSchema } from "../common/http_pb.js";
import { file_agentplatform_common_http } from "../common/http_pb.js";
import type { GenericServiceSecretData, Secret } from "../v2/secret_pb.js";
import { file_agentplatform_v2_secret } from "../v2/secret_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/secret.proto.
 */
export const file_agentplatform_httpv2_secret: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_common_http, file_agentplatform_v2_secret, file_buf_validate_validate, file_google_api_annotations, file_google_api_field_behavior]);

/**
 * ============================= Create =============================
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSecretRequest
 */
export type CreateSecretRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateSecretRequest"> & {
  /**
   * @gotags: json:"secret"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.Secret secret = 1;
   */
  secret?: Secret | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSecretRequest.
 * Use `create(CreateSecretRequestSchema)` to create a new message.
 */
export const CreateSecretRequestSchema: GenMessage<CreateSecretRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 0);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSecretResponse
 */
export type CreateSecretResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateSecretResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CreateSecretData data = 4;
   */
  data?: CreateSecretData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSecretResponse.
 * Use `create(CreateSecretResponseSchema)` to create a new message.
 */
export const CreateSecretResponseSchema: GenMessage<CreateSecretResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSecretData
 */
export type CreateSecretData = Message<"infinigence.infini.agentplatform.httpv2.CreateSecretData"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSecretData.
 * Use `create(CreateSecretDataSchema)` to create a new message.
 */
export const CreateSecretDataSchema: GenMessage<CreateSecretData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 2);

/**
 * ============================= Get =============================
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSecretResponse
 */
export type GetSecretResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSecretResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 敏感字段已按类型脱敏
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.Secret data = 4;
   */
  data?: Secret | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSecretResponse.
 * Use `create(GetSecretResponseSchema)` to create a new message.
 */
export const GetSecretResponseSchema: GenMessage<GetSecretResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 3);

/**
 * ============================= List =============================
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSecretsResponse
 */
export type ListSecretsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSecretsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSecretsData data = 4;
   */
  data?: ListSecretsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSecretsResponse.
 * Use `create(ListSecretsResponseSchema)` to create a new message.
 */
export const ListSecretsResponseSchema: GenMessage<ListSecretsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSecretsData
 */
export type ListSecretsData = Message<"infinigence.infini.agentplatform.httpv2.ListSecretsData"> & {
  /**
   * 敏感字段已按类型脱敏
   * @gotags: json:"data"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v2.Secret data = 1;
   */
  data: Secret[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSecretsData.
 * Use `create(ListSecretsDataSchema)` to create a new message.
 */
export const ListSecretsDataSchema: GenMessage<ListSecretsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 5);

/**
 * ============================= Update =============================
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSecretRequest
 */
export type UpdateSecretRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateSecretRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"secret"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.Secret secret = 2;
   */
  secret?: Secret | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSecretRequest.
 * Use `create(UpdateSecretRequestSchema)` to create a new message.
 */
export const UpdateSecretRequestSchema: GenMessage<UpdateSecretRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSecretResponse
 */
export type UpdateSecretResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateSecretResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 敏感字段已按类型脱敏
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.Secret data = 4;
   */
  data?: Secret | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSecretResponse.
 * Use `create(UpdateSecretResponseSchema)` to create a new message.
 */
export const UpdateSecretResponseSchema: GenMessage<UpdateSecretResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 7);

/**
 * ============================= Delete =============================
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSecretResponse
 */
export type DeleteSecretResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteSecretResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSecretResponse.
 * Use `create(DeleteSecretResponseSchema)` to create a new message.
 */
export const DeleteSecretResponseSchema: GenMessage<DeleteSecretResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 8);

/**
 * ============================= DecryptDEK =============================
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DecryptDEKRequest
 */
export type DecryptDEKRequest = Message<"infinigence.infini.agentplatform.httpv2.DecryptDEKRequest"> & {
  /**
   * 随沙箱参数下发的 wrapped_dek（base64）
   * @gotags: json:"wrapped_dek"
   *
   * @generated from field: string wrapped_dek = 1 [json_name = "wrapped_dek"];
   */
  wrappedDek: string;

  /**
   * 包装该 DEK 所用的 KEK 版本引用；服务端据此选对应 KEK 解包。
   * @gotags: json:"kek_ref"
   *
   * @generated from field: string kek_ref = 2 [json_name = "kek_ref"];
   */
  kekRef: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DecryptDEKRequest.
 * Use `create(DecryptDEKRequestSchema)` to create a new message.
 */
export const DecryptDEKRequestSchema: GenMessage<DecryptDEKRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DecryptDEKResponse
 */
export type DecryptDEKResponse = Message<"infinigence.infini.agentplatform.httpv2.DecryptDEKResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.DecryptDEKData data = 4;
   */
  data?: DecryptDEKData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DecryptDEKResponse.
 * Use `create(DecryptDEKResponseSchema)` to create a new message.
 */
export const DecryptDEKResponseSchema: GenMessage<DecryptDEKResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DecryptDEKData
 */
export type DecryptDEKData = Message<"infinigence.infini.agentplatform.httpv2.DecryptDEKData"> & {
  /**
   * 明文 DEK（base64，经 HTTPS 返回）
   * @gotags: json:"dek"
   *
   * @generated from field: string dek = 1;
   */
  dek: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DecryptDEKData.
 * Use `create(DecryptDEKDataSchema)` to create a new message.
 */
export const DecryptDEKDataSchema: GenMessage<DecryptDEKData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 11);

/**
 * ============================= ValidateOSSSecret =============================
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ValidateOSSSecretRequest
 */
export type ValidateOSSSecretRequest = Message<"infinigence.infini.agentplatform.httpv2.ValidateOSSSecretRequest"> & {
  /**
   * 待验证的 bucket 列表（校验凭证对这些 bucket 是否可达）
   * @gotags: json:"buckets"
   *
   * @generated from field: repeated string buckets = 1;
   */
  buckets: string[];

  /**
   * 校验已有凭证时传其 id（后端解密后校验）；与下方 oneof data 二选一。
   * @gotags: json:"secret_id,omitempty"
   *
   * @generated from field: string secret_id = 2 [json_name = "secret_id"];
   */
  secretId: string;

  /**
   * 校验新建凭证时传明文数据，选中分支即密钥类型。与 secret_id 二选一。
   *
   * @generated from oneof infinigence.infini.agentplatform.httpv2.ValidateOSSSecretRequest.data
   */
  data: {
    /**
     * 阿里云 OSS
     * @gotags: json:"aliyun_oss,omitempty"
     *
     * @generated from field: infinigence.infini.agentplatform.v2.GenericServiceSecretData aliyun_oss = 10 [json_name = "aliyun_oss"];
     */
    value: GenericServiceSecretData;
    case: "aliyunOss";
  } | {
    /**
     * 火山 TOS
     * @gotags: json:"volcengine_tos,omitempty"
     *
     * @generated from field: infinigence.infini.agentplatform.v2.GenericServiceSecretData volcengine_tos = 11 [json_name = "volcengine_tos"];
     */
    value: GenericServiceSecretData;
    case: "volcengineTos";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ValidateOSSSecretRequest.
 * Use `create(ValidateOSSSecretRequestSchema)` to create a new message.
 */
export const ValidateOSSSecretRequestSchema: GenMessage<ValidateOSSSecretRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ValidateOSSSecretResponse
 */
export type ValidateOSSSecretResponse = Message<"infinigence.infini.agentplatform.httpv2.ValidateOSSSecretResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ValidateOSSSecretResponse.
 * Use `create(ValidateOSSSecretResponseSchema)` to create a new message.
 */
export const ValidateOSSSecretResponseSchema: GenMessage<ValidateOSSSecretResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_secret, 13);

/**
 * @generated from service infinigence.infini.agentplatform.httpv2.SecretHTTPV2Service
 */
export const SecretHTTPV2Service: GenService<{
  /**
   * 创建 Secret（存储侧加密落库）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SecretHTTPV2Service.CreateSecret
   */
  createSecret: {
    methodKind: "unary";
    input: typeof CreateSecretRequestSchema;
    output: typeof CreateSecretResponseSchema;
  },
  /**
   * 获取单个 Secret（敏感字段按类型脱敏）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SecretHTTPV2Service.GetSecret
   */
  getSecret: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetSecretResponseSchema;
  },
  /**
   * 分页列出 Secret（敏感字段按类型脱敏）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SecretHTTPV2Service.ListSecrets
   */
  listSecrets: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListSecretsResponseSchema;
  },
  /**
   * 全量更新 Secret
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SecretHTTPV2Service.UpdateSecret
   */
  updateSecret: {
    methodKind: "unary";
    input: typeof UpdateSecretRequestSchema;
    output: typeof UpdateSecretResponseSchema;
  },
  /**
   * 删除 Secret
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SecretHTTPV2Service.DeleteSecret
   */
  deleteSecret: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof DeleteSecretResponseSchema;
  },
  /**
   * 解密 DEK：sandbox-manager 用随沙箱参数下发的 wrapped_dek 换回 DEK。
   * 本阶段走标准 IAM 鉴权；限定 Service Account 的接口级授权留下阶段。
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SecretHTTPV2Service.DecryptDEK
   */
  decryptDEK: {
    methodKind: "unary";
    input: typeof DecryptDEKRequestSchema;
    output: typeof DecryptDEKResponseSchema;
  },
  /**
   * 联网校验对象存储凭证对指定 bucket 是否可达。保存沙箱/创建凭证前预校验，
   * 避免 ak/sk 写错时留下不可用的孤儿凭证。凭证来源二选一：secret_id（已有凭证）
   * 或 oneof data（新建凭证的明文）。
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SecretHTTPV2Service.ValidateOSSSecret
   */
  validateOSSSecret: {
    methodKind: "unary";
    input: typeof ValidateOSSSecretRequestSchema;
    output: typeof ValidateOSSSecretResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_secret, 0);

